import { c as _c } from "react/compiler-runtime";
import { AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { PipelineCreateStageInterface, PipelineEditInterface } from 'modules/crm/types/pipeline-interface';
import React, { Dispatch, SetStateAction, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { BinIcon, DragIcon } from '@systemeio/ui/icons';
const animateLayoutChanges: AnimateLayoutChanges = args => defaultAnimateLayoutChanges({
  ...args,
  wasDragging: true
});
interface PropsStatusesItem {
  setTempState: Dispatch<SetStateAction<PipelineEditInterface>>;
  stage: PipelineCreateStageInterface;
  showBin: boolean;
  withConfirmation?: boolean;
  error?: string;
}
export const StageItem = t0 => {
  const $ = _c(50);
  const {
    stage,
    setTempState,
    showBin,
    withConfirmation,
    error
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [isOpenedConfirmation, setIsOpenedConfirmation] = useState(false);
  let t1;
  if ($[0] !== stage.position) {
    t1 = {
      id: stage.position,
      animateLayoutChanges
    };
    $[0] = stage.position;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    attributes,
    isDragging,
    listeners,
    setNodeRef,
    transition,
    transform
  } = useSortable(t1);
  let t2;
  if ($[2] !== transform) {
    t2 = CSS.Translate.toString(transform);
    $[2] = transform;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isDragging ? 0.5 : undefined;
  let t4;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== transition) {
    t4 = {
      transition,
      transform: t2,
      opacity: t3
    };
    $[4] = t2;
    $[5] = t3;
    $[6] = transition;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const style = t4;
  let t5;
  if ($[8] !== setTempState) {
    t5 = (stages, value) => {
      setTempState(prevState => ({
        ...prevState,
        stages: prevState.stages.map(item => {
          if (item.position === stages.position) {
            return {
              ...item,
              name: value
            };
          }
          return item;
        })
      }));
    };
    $[8] = setTempState;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handelChangeNameStage = t5;
  let t6;
  if ($[10] !== setTempState || $[11] !== stage.position) {
    t6 = () => setTempState(prevState_0 => ({
      ...prevState_0,
      stages: prevState_0.stages.filter(item_0 => item_0.position !== stage.position)
    }));
    $[10] = setTempState;
    $[11] = stage.position;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const removeStage = t6;
  const t7 = `focus-within:border-brand-primary disabled:bg-background-tertiary/40 group/item flex rounded-lg border px-4 py-3 transition ${error ? "border-danger" : "border-text-secondary/30"}`;
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <DragIcon className="mr-4 cursor-grab" />;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t) {
    t9 = t("dashboard.crm_pipeline.modal.placeholder_name_pipeline");
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== handelChangeNameStage || $[17] !== stage) {
    t10 = e => handelChangeNameStage(stage, e.target.value);
    $[16] = handelChangeNameStage;
    $[17] = stage;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== stage.name || $[20] !== t10 || $[21] !== t9) {
    t11 = <input type="text" spellCheck={false} placeholder={t9} onChange={t10} value={stage.name} className="text-brand-primary placeholder:text-text-tertiary/70 basis-full text-[17px] font-medium focus:outline-hidden" />;
    $[19] = stage.name;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== removeStage || $[24] !== showBin || $[25] !== withConfirmation) {
    t12 = showBin && <button onClick={_temp} className="group-hover/item:visible group invisible"><BinIcon onClick={() => withConfirmation ? setIsOpenedConfirmation(true) : removeStage()} className="group-hover:fill-danger group-focus-visible:fill-danger main-transition-colors h-[20px] w-[20px] " /></button>;
    $[23] = removeStage;
    $[24] = showBin;
    $[25] = withConfirmation;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== attributes || $[28] !== listeners || $[29] !== setNodeRef || $[30] !== style || $[31] !== t11 || $[32] !== t12 || $[33] !== t7) {
    t13 = <div className={t7} ref={setNodeRef} style={style} {...attributes} {...listeners}>{t8}{t11}{t12}</div>;
    $[27] = attributes;
    $[28] = listeners;
    $[29] = setNodeRef;
    $[30] = style;
    $[31] = t11;
    $[32] = t12;
    $[33] = t7;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== error) {
    t14 = <FieldErrorAndDescription error={error} />;
    $[35] = error;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => setIsOpenedConfirmation(false);
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== removeStage) {
    t16 = () => removeStage();
    $[38] = removeStage;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== t) {
    t17 = t("dashboard.crm_pipeline.edit_modal.confirmation_text");
    $[40] = t;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== isOpenedConfirmation || $[43] !== t16 || $[44] !== t17) {
    t18 = <ConfirmationModal opened={isOpenedConfirmation} onClose={t15} onConfirm={t16} confirmationText={t17} />;
    $[42] = isOpenedConfirmation;
    $[43] = t16;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t13 || $[47] !== t14 || $[48] !== t18) {
    t19 = <div className="mb-4 mr-2">{t13}{t14}{t18}</div>;
    $[46] = t13;
    $[47] = t14;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  return t19;
};
function _temp() {}